import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
//增加目录 
  getData.Pcats= (data)=>{ 
    return http.post(baseUrl+"/accessory/cats/",data)
  }
// 查看目录
  getData.Gcats= (data)=>{ 
    return http.get(baseUrl+"/accessory/cats/",{ params:data })
  }
// 修改目录
  getData.PAcats= (pk,data)=>{ 
    return http.patch(baseUrl+"/accessory/cat/"+pk+"/",data)
  }
  //批量删除目录
  getData.DELcats = (pk,data)=>{ 
    return http.delete(baseUrl+"/accessory/cats/multi_del/?ids="+pk,data)
  }
  //增加参数 --
  getData.Pcparams= (data)=>{ 
    return http.post(baseUrl+"/accessory/cparams/",data)
  }
  //修改参数 --
  getData.PAcparam= (pk,data)=>{
    return http.patch(baseUrl+"/accessory/cparam/"+pk+"/",data)
  }
  //批量删除参数 --
  getData.DELcparam= (pk,data)=>{
    return http.delete(baseUrl+"/accessory/cparams/multi_del/?ids="+pk,data)
  }
  // 查看参数
  getData.Gcparams= (pk,data)=>{ 
    return http.get(baseUrl+"/accessory/cat/"+pk+"/",{ params:data })
  }
  //增加配件库
  getData.Pacces= (data)=>{ 
    return http.post(baseUrl+"/accessory/acces/",data)
  }
  //上传图片接口
  getData.PUploadPic= (data)=>{ 
    return http.post(baseUrl+"/accessory/apics/",data)
  }
  //删除图片接口 --
  getData.DelUploadPic= (pk,data)=>{
    return http.delete(baseUrl+"/accessory/apic/"+pk+"/",data)
  }
  //上传图片特色服务
  getData.PSUploadPic= (data)=>{ 
    return http.post(baseUrl+"/accessory/spics/",data)
  }
  //删除图片特色服务 --
  getData.DelSUploadPic= (pk,data)=>{
    return http.delete(baseUrl+"/accessory/spic/"+pk+"/",data)
  }
  // 查看全部接口内容
  getData.GAllacces= (data)=>{ 
    return http.get(baseUrl+"/accessory/acces/",{ params:data })
  }
  // 获取单个配件库详情
  getData.Gacce= (pk,data)=>{ 
    return http.get(baseUrl+"/accessory/acce/"+pk+"/",{ params:data })
  }
  // 修改配件信息
  getData.PAcce= (pk,data)=>{ 
    return http.patch(baseUrl+"/accessory/acce/"+pk+"/",data)
  }
  //删除配件单个
  getData.DelAcce= (pk,data)=>{
    return http.delete(baseUrl+"/accessory/acce/"+pk+"/",data)
  }
  // 目录嵌套的展示
  getData.GAllnesteds= (data)=>{ 
    return http.get(baseUrl+"/accessory/cats_nested/",{ params:data })
  }
  // 上架 下架 配件库批量
  getData.PmultiActive= (pk,data)=>{ 
    return http.patch(baseUrl+"/accessory/acces/multi_active/?ids="+pk,data)
  }
  // 删除配件库批量
  getData.PmultiDel= (pk,data)=>{ 
    return http.delete(baseUrl+"/accessory/acces/multi_del/?ids="+pk,data)
  }
  //收藏和取消收藏
  getData.Pcolacce= (data)=>{ 
    return http.post(baseUrl+"/accessory/colacce/",data)
  }
export default getData


// WEBPACK FOOTER //
// ./src/common/parts.js